import { useEffect } from "react";
import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setTotal, setNetTotal } from "../slice/discAndTaxSlice";

const Calculation = () => {
  const dispatch = useDispatch();

  // Selecting data from Redux state
  const tableData = useSelector((state) => state.tableData);
  const total = useSelector((state) => state.discAndTax.total);
  const netTotal = useSelector((state) => state.discAndTax.netTotal);
  const decimalCount = useSelector((state) => state.common.decimalCount);
  const isRoundOffInv = useSelector((state) => state.common.isRoundOffInv);

  // Calculate the total QTY
  const totalQty = tableData.reduce((acc, cur) => {
    return acc + (Number(cur.qty) || 0);
  }, 0);

  // Calculate the total amount
  const totalCalc = tableData.reduce((acc, cur) => {
    return acc + (Number(cur.total) || 0);
  }, 0);

  // Use an effect to update total and netTotal when dependencies change
  useEffect(() => {
    dispatch(setTotal(totalCalc));
    dispatch(setNetTotal(isRoundOffInv ? Math.round(totalCalc) : totalCalc));
  }, [totalCalc, isRoundOffInv, dispatch]);

  return (
    <Box component={Paper} elevation={3} sx={{ p: 1.5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {/* Left side empty for future use or to keep layout */}
        </Grid>
        <Grid item xs={12} md={6} alignContent={"flex-end"}>
          <Grid container justifyContent={"flex-end"}>
            <Grid item xs={6} md={4}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="h4" gutterBottom>
                  Total Qty :
                </Typography>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{ textAlign: "right" }}
                >
                  {totalQty.toFixed(2)}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="h4">Net Total :</Typography>
                <Typography variant="h4" sx={{ textAlign: "right" }}>
                  {netTotal.truncateDecimal
                    ? netTotal.truncateDecimal(decimalCount)
                    : Number(netTotal).toFixed(decimalCount || 2)}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Calculation;
